
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.333 30.227L14.5 32.061l-1.833-1.834-1.834 1.834-2.894-2.894 1.834-1.834L7.939 25.5l1.834-1.833-1.834-1.834L9.773 20l-1.834-1.833 1.834-1.834L7.939 14.5l1.834-1.833-1.834-1.834 2.894-2.894 1.834 1.834L14.5 7.939l1.833 1.834 1.834-1.834L20 9.773l1.833-1.834 1.834 1.834L25.5 7.939l1.833 1.834 1.834-1.834 2.894 2.894-1.834 1.834 1.834 1.833-1.834 1.833 1.834 1.834L30.227 20l1.834 1.833-1.834 1.834 1.834 1.833-1.834 1.833 1.834 1.834-2.894 2.894-1.834-1.834-1.833 1.834-1.833-1.834-1.834 1.834L20 30.227l-1.833 1.834-1.834-1.834z","stroke":"#409EFF","stroke-width":"1.5","fill":"none"}})])
          )
        }
      }
    